import { createContext } from 'react';
import { AnalyticsManager } from './types';

export const AnalyticsContext = createContext<AnalyticsManager | undefined>(undefined);
